module.exports = __webpack_public_path__ + "static/img/SourceSansPro-Light.82c7072.svg";